import React, { useState, useEffect } from 'react';
import useReduxState from "../../../hooks/useReduxState";
import store from "src/storeWire";
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import System from 'src/helper/system';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/custom/DisplayLongDescriptionAndVariantMFRName';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useSystem } from "src/hooks/system";

const InventoryAlertForAddToCartPopup = (props) => {
    const { SetStatus } = props;
    const [, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [{ }, { get_inventory_lead_time, get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const [{ }, { update_BackOrder_Quantity_ToCartServer, get_Validate_Cart_From_Server }, { ADD_TO_CART }] = useCartStore();
    const [load, SetLoad] = useState(false);
    const [{ system_alert_list }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { single_product, isFrom = false, addToCartParam, isFromManualCart = false } = props.data
    const [,{ get_quantity_format }] = useSystem();

    useEffect(() => {
        SetStatus(true)
    }, []);

    const onHide = (action = true) => {
        SetStatus(false)
        if (action) {
            store.dispatch(SET_ADD_CART_DATA(false))
        }
    };

    const onSubmit = async (e) => {
        if (load) {
            e.preventDefault();
            return false;
        }
        SetLoad(true);
        if (isFrom === "Cart" && isFromManualCart === false) {
            let cartDetailItems = []
            Object.entries(single_product).map(v => {
                const cart = {
                    "cartDetailId": v[1].cartDetailId,
                    "backOrderedQuantity": v[1].quantity - get_inventory_by_id(v[1].ItemNumber)?.inventoryQty || 0
                }
                cartDetailItems.push(cart)
            })
            const payload = {
                "cartId": localStorage.getItem(System.storageName.CART_ID),
                "cartDetailItems": cartDetailItems
            }
            await update_BackOrder_Quantity_ToCartServer(payload)

            if (Object.keys(system_alert_list).includes('BackOrderedItem')) {
                remove_system_alert_indicator('BackOrderedItem')
            }
        } else {
            const payload = {
                ...addToCartParam,
                'isBackOrder': true
            }
            const res = await ADD_TO_CART(payload, isFrom, single_product, isFromManualCart);

            if (isFrom === 'Cart' && !res?.data?.isBackOrderConfirmation) {
                //added by Ramya
                 updateCartEvent(res);
                await get_Validate_Cart_From_Server({ shipToAddressId: System.getUserShippingAddress() })
            }
        }

        setProductSelected({});
        setSearchTerm('');
        SetLoad(false);
        onHide(false);
    }

    //By Ramya Kannan [update cart - Adobe script ]
    function updateCartEvent(selectedProd){ 
       localStorage.setItem("adobeEventType","addToCartEvent");
        let prodDetails = selectedProd;
        let cartDetails = {
            "additionSource" : "cartView",
            "cartType" : "checkout"
        }
        if(Object.keys(prodDetails).length && Object.keys(cartDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails});
        }

   }

    return (
        <div className="avnet-modal modal-680 inventoryalert-modal">
            <div className="avnet-modal-inner">
                {/* Modal Header */}
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => {
                        onHide()
                        if (isFrom === "Cart") {
                            system_alert_indicator({
                                name: 'BackOrderedItem',
                                message: "Error: To proceed, please update the quantity or remove the highlighted insufficient inventory items from your cart.",
                                type: "danger",
                                isDisplay: false,
                                isDisplayIcon: true
                            })
                        }
                    }}>×
                </button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading">Inventory Alert</h3>
                </div>
                <div className="m-4 mt-0">
                    <div className="">
                        We currently do not have sufficient inventory for the following item(s) in your cart. <br />Would you like to place backorder for these items?
                    </div>
                </div>
                <div className="modal-body">
                    <div className="inventory-table">
                        <table className="table table-outline rounded-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="border-0 text-none font-12">Product(s)</th>
                                    <th className="border-0 text-none font-12">Requested Quantity</th>
                                    <th className="border-0 text-none font-12">Backorder Quantity</th>
                                </tr>
                            </thead>
                            <tbody className="border-top-0">
                                {single_product.map(product => (
                                    <tr key={product.ItemNumber}>
                                        <td className="align-middle">
                                            <div className="inventory-product-info">
                                                
                                                
                                                 {/* <div className="inventory-product-name">
                                                    <NavigateToProductDetail data={{ SEOManufacturerName: product?.seoManufacturerName, SEOERPMFRPartNumber: product?.seoerpmfrPartNumber, ItemNumber: product?.ItemNumber, ERPPartNumber: product?.ERPPartNumber }}>
                                                    {console.log("Product debug1:", product)}
                                                    
                                                        <b className='text-black'>{product.ManufacturerPartNumber}</b>
                                                    </NavigateToProductDetail>
                                                </div> */}
                                                
                                                <div className="inventory-product-name">
                                                    <b className="text-black">
                                                        {product?.ManufacturerPartNumber}
                                                        </b>
                                                </div>
                                                <div className="inventory-product-by">
                                                    <DisplayLongDescriptionAndVariantMFRName
                                                        currentProduct={{ ManufacturerName: product?.ManufacturerName, ShortDescription: product?.ShortDescription }}
                                                        inventory_alert_popup={true} />
                                                </div>
                                                <div className="inventory-product-stock"><b>In Stock: {get_quantity_format(get_inventory_by_id(product.ItemNumber)?.inventoryQty)}</b>
                                                    {get_inventory_by_id(product.ItemNumber)?.factoryStock > 0 && (
                                                        <div className="inventory-product-stock"><b>Factory Stock: {get_quantity_format(get_inventory_by_id(product.ItemNumber)?.factoryStock)}</b>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="inventory-product-lead">Lead Time From Supplier: {get_inventory_lead_time(product?.FactoryLeadTime, product?.constrainPartFlag)}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="align-middle">
                                            <span>{get_quantity_format(product.quantity)}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span>{get_quantity_format(product.backOrderedQuantity)}</span>
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal-footer justify-content-center">
                    <div className="modal-footer-actions">
                        <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                            disabled={load}
                            data-bs-toggle="modal" data-bs-target="#InventoryModal"
                            onClick={() => {
                                onHide()
                                if (isFrom === "Cart") {
                                    system_alert_indicator({
                                        name: 'BackOrderedItem',
                                        message: "Error: To proceed, please update the quantity or remove the highlighted insufficient inventory items from your cart.",
                                        type: "danger",
                                        isDisplay: false,
                                        isDisplayIcon: true
                                    })
                                }
                            }}>
                            No
                        </button>
                        <button type="button" className="bs5 btn btn-primary btn-sm w145"
                            onClick={onSubmit}>
                            {load ? <i className="fa fa-spinner fa-spin" /> : <>Yes</>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryAlertForAddToCartPopup;